import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { IProtectedRoute } from "../Interfaces/IProtectedRoute";

export const ProtectedRoute: React.FC<IProtectedRoute> = ({
  path,
  component,
  nestedRoutedParent,
  routes,
}) => {
  const user = useSelector((state: any) => state.auth.user);
  return user && user?.isLDMUser ? (
    <Route path={path} component={component} />
  ) : (
    <Redirect to={"/login"} />
  );
};

export default ProtectedRoute;
